<template>

    <div class="container card p-5 shadow col-md-5 m-auto">
        
        <h1>Register Doctor</h1>
        <hr>
        
        <div v-if="response.success != null" v-bind:class="{ 'alert-success': response.success, 'alert-danger': !response.success }" class="alert" role="alert">
            {{response.message}}
        </div>

        <div id="form">
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-lg">First Name</span>
                </div>
                <input v-model="doctorProfile.firstName" type="text" class="form-control" placeholder="Enter First Name">
            </div>
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-lg">Last Name</span>
                </div>
                <input v-model="doctorProfile.lastName" type="text" class="form-control" placeholder="Enter Last Name">
            </div>
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-lg">Email</span>
                </div>
                <input v-model="doctorProfile.email" type="email" class="form-control" placeholder="Enter Email">
            </div>
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-lg">Riziv</span>
                </div>
                <input v-model="doctorProfile.riziv" type="text" class="form-control"  placeholder="Enter Riziv">
            </div>
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-lg">Phone</span>
                </div>
                <input v-model="doctorProfile.phoneNumber" type="text" class="form-control"  placeholder="Enter Phone">
            </div>
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-lg">City</span>
                </div>
                <input v-model="doctorProfile.city" type="text" class="form-control"  placeholder="Enter City">
            </div>
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-lg">Address</span>
                </div>
                <input v-model="doctorProfile.address" type="text" class="form-control"  placeholder="Enter Address">
            </div>
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-lg">Postcode</span>
                </div>
                <input v-model="doctorProfile.postcode" type="text" class="form-control"  placeholder="Enter Postcode">
            </div>
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" for="inputGroupSelect01">Language
                        <img v-if="selectedLanguageObj" class="img-profile ml-2 rounded-circle" :src="selectedLanguageObj.flagImagePath">
                    </span>
                </div>
                <select v-model="doctorProfile.languageId" class="custom-select" id="inputGroupSelect01">
                    <option v-for="(lang,index) in languages" :key="index"  :selected='index == 1' :value="lang.id">
                        {{lang.longTitle}} 
                    </option>
                </select>
            </div>
        </div>
        <button @click="addDoctorProfile()" type="button" class="btn btn-primary mb-3 col-md-4">Save Changes</button>
    </div>

</template>
<script>
export default {
    data() {
        return {
            doctorProfile :
            {
                "firstName": "",
                "lastName": "",
                "email": "",
                "riziv": "",
                "phoneNumber": "",
                "city": "",
                "postcode": "",
                "address": "",
                "language": {},
                "languageId": ""
            },
            response: {
                success: null,
                message: "",
                doctorId: null
            },
            
        }
    },
    methods: {
        addDoctorProfile: function(){
            let self = this;
            this.$http.post("/api/doctor/add", this.doctorProfile)
                .then(response =>
                {
                    self.response = response.data;
                })
                .catch();
        },
    },
    created: function () {
        
    },
    watch: {
        response: function(val){
            if(val.success === true){
                for (var key in this.doctorProfile ) 
                    this.doctorProfile[key] = '';
                setTimeout(() => {
                    this.$router.push("/admin/doctors/info/" + this.response.doctorId);
                }, 1000)
            }
            setTimeout(() => {
                this.response.success = null;
            }, 3000)
        },
        languages: function(val){
            this.doctorProfile.languageId = this.languages[0].id;
        }
    },
    computed: {
        languages: function(){
            var tempLanguages = this.$store.getters.systemLanguages;
            return tempLanguages;
        },
        selectedLanguageObj: function(){
            var tempSelectedLanguageObj = this.languages.find(obj => {
                return obj.id === this.doctorProfile.languageId;
            })
            return tempSelectedLanguageObj;
        }
    }
}
</script>
<style lang="scss" scoped>
div{
    span.input-group-text {
        width: 130px;
    }
}
.rounded-circle {
            height : 1.5rem;
            width : 1.5rem;
        }
</style>

